export const chatTabTypes = {
  text: "テキスト",
  file: "ファイル",
  search: "検索",
  cost: "費用",
};
